import ResumeItem from "@/common/components/ResumeItem";
import { checkinEntryOptions } from "@/features/maintenance/features/workflows/constants/forwardings/steps/checkinEntry/checkinEntryOptions.constant";
import { useForwardingTabContext } from "@/features/maintenance/features/workflows/hooks/forwardings/useForwardingTabContext";
import { MaintenanceForwardingsDirectiveEntryKlass } from "@/features/maintenance/features/workflows/types/forwardings/maintenanceForwardingsDirectiveEntryKlasses.type";
import EstablishmentChoiceEntryProposal from "../../../../proposal";

const DirectiveEntryDiagnosticEntryPending = () => {
  const { forwarding } = useForwardingTabContext<MaintenanceForwardingsDirectiveEntryKlass.DiagnosticEntry>();

  return (
    <>
      <div className="flex flex-col gap-3">
        <div className="flex gap-3">
          {forwarding.directive_entry?.complexity && (
            <ResumeItem
              label="Complexidade"
              value={forwarding.directive_entry?.complexity?.display_name}
              className="text-xs"
              valueClassName="font-bold text-sm"
            />
          )}

          {forwarding.directive_entry?.deadline_to_complete_in_days != null && (
            <ResumeItem
              label="Resposta esperada até"
              value={
                forwarding.directive_entry?.deadline_to_complete_in_days
                  ? `${forwarding.directive_entry?.deadline_to_complete_in_days} dias`
                  : '--'
              }
              className="text-xs"
              valueClassName="font-bold text-sm"
            />
          )}
        </div>

        <div className="flex gap-3">
          {forwarding.checkin_entry_type && (
            <ResumeItem
              label="Tipo de transporte"
              value={checkinEntryOptions[forwarding.checkin_entry_type].title}
              className="text-xs"
              valueClassName="font-bold text-sm"
            />
          )}

          {forwarding.checkin_entry.responsible && (
            <ResumeItem
              label="Responsável por Transporte"
              value={forwarding.checkin_entry?.responsible.full_name || '--'}
              className="text-xs"
              valueClassName="font-bold text-sm"
            />
          )}
        </div>
      </div>

      <EstablishmentChoiceEntryProposal
        proposal={forwarding.establishment_choice_entry.actual_proposal}
      />
    </>
  );
}

export default DirectiveEntryDiagnosticEntryPending;
